module.exports = __webpack_public_path__ + "media/images/icons/alert-48808655283c27548968e8ff947abcb3.svg";